__turbopack_context__.v({
  "ApplicationButton": "Applications-module-scss-module__tMQiWa__ApplicationButton",
  "application": "Applications-module-scss-module__tMQiWa__application",
  "applicationVisual": "Applications-module-scss-module__tMQiWa__applicationVisual",
  "arrowIcon": "Applications-module-scss-module__tMQiWa__arrowIcon",
  "buttonContent": "Applications-module-scss-module__tMQiWa__buttonContent",
  "content": "Applications-module-scss-module__tMQiWa__content",
  "inner": "Applications-module-scss-module__tMQiWa__inner",
  "wrap": "Applications-module-scss-module__tMQiWa__wrap",
});
